module.exports = "/fonts/FiraSans-LightItalic.ttf";